module.exports = __webpack_public_path__ + "img/united-states-of-america.e499f1fb.png";